import { useQuery } from 'react-query';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import codes from '../utils/constants/codes';

export const useTermsAndConditions = (
    areTermsConsented: any,
    currentCountry: any,
    userId: any,
    selectedLanguageId: string,
) => {
    return useQuery({
        queryKey: ['termsAndCondition', selectedLanguageId],
        queryFn: async () => {
            let respone =
                await GENERAL_FUNCTIONS.fetchTermsAndConditions(
                    selectedLanguageId,
                );
            return respone.data;
        },
        enabled:
            userId !== undefined &&
            !areTermsConsented &&
            currentCountry == codes.canadaCode,
    });
};
